import { ResourceIdentifier } from '@cube3/common/model/resource-types';
import { actionCreators as edgeActionCreators } from '../../../ducks/resource-edges';
import { handleFilesPreCreate } from './handleFilesPreCreate';
import { handleFilesPostCreate } from './handleFilesPostCreate';

/** continue resumable upload nested in a parentResource */
export const continueNestedUpload = (
  file,
  metadata,
  parentResource: ResourceIdentifier,
  dispatch,
  getState,
  idx = 0
) => {
  const { uploadIds } = handleFilesPreCreate(
    dispatch,
    getState
  )({
    files: [file],
    ancestorId: parentResource.id,
    ancestorType: parentResource.type
  });

  handleFilesPostCreate(dispatch, getState, idx)(
    {
      resourceType: 'asset',
      ancestorId: parentResource.id,
      ancestorType: parentResource.type,
      files: [file]
    },
    {
      id: metadata.targetResourceId,
      type: metadata.targetResourceType
    },
    uploadIds,
    false
  );
  // NOTE: we can ignore the promise because we
  // don't have to set requeststatus for any action here

  dispatch(
    edgeActionCreators.receiveResourceEdges(
      metadata.targetResourceId,
      'asset',
      'file-uploads',
      'file-upload',
      [
        {
          id: file.id,
          type: 'file-upload'
        }
      ]
      // { merge: true }
    )
  );
};
